import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, ['dueThreshold', 'billType', 'accountType', 'status'])}`
    : '';
  const getInvoicePaymentReconcileReport = `getInvoicePaymentReconcileReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getInvoicePaymentReconcileReport} {
        billId
        startDate
        endDate
        invoiceId
        invoiceDate
        dueDate
        accountId
        firstName
        lastName
        company
        total
        nonPayingTotal
        billTotal
        due
        accountType
        billType
        status
        payment
        writeoff
        adjusted
        refund
        settlement
        disputed
        invoiceTransferred
        chargeBack
      }
    }
  `;
};
